import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

import { updateUser, getUser, fetchUser } from 'store/userReducer'
import UserForm from './UserForm'
import Spin from 'components/ui/Spin'

class UserEditContainer extends Component {
  componentDidMount() {
    const { match } = this.props
    this.props.fetchUser(match.params.id)
  }

  render() {
    const { handleSubmit, user } = this.props

    if (isEmpty(user)) {
      return <Spin />
    } else {
      return <UserForm onSubmit={handleSubmit} initialValues={user}  />
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id
  return {
    user: getUser(state, id)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    fetchUser,
    handleSubmit: values => {
      return updateUser([values, () => ownProps.history.push('/account/users')])
    }
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEditContainer)



// WEBPACK FOOTER //
// ./src/features/user/UserEditContainer.js